import { useCallback, useState } from 'react';

type FiltersRecord = Record<string, string>;

export const useNewFilterList = () => {
  const [selectedFilters, setSelectedFilters] = useState<FiltersRecord>({});
  const [dateRange, setDateRange] = useState<{ start: any; end: any }>({
    start: null,
    end: null,
  });
  const [trigger, setTrigger] = useState(false);
  const [clear, setClear] = useState(false);
  const [refreshRelator, setRefreshRelator] = useState(false);
  const [filters, setFilters] = useState<any>(null);

  const updateSelectedFilters = useCallback((updatedValues: FiltersRecord) => {
    setSelectedFilters((prevFilters) => {
      const hasChanged = Object.keys(updatedValues).some(
        (key) => prevFilters[key] !== updatedValues[key],
      );

      if (!hasChanged) return prevFilters;

      return { ...prevFilters, ...updatedValues };
    });
  }, []);

  const handleStateUpdate = (newState: any) => {
    if (newState && newState.dateRange) setDateRange(newState.dateRange);
    if (newState && newState.trigger !== undefined)
      setTrigger(newState.trigger);
    if (newState && newState.clear !== undefined) {
      setClear(newState.clear);
      // props.setClearForChildren(clear);
    }
  };

  return {
    selectedFilters,
    dateRange,
    trigger,
    clear,
    refreshRelator,
    filters,
    setSelectedFilters,
    setDateRange,
    setTrigger,
    setClear,
    setRefreshRelator,
    setFilters,
    updateSelectedFilters,
    handleStateUpdate,
  };
};
